// 路由
export const routes = [
  {
    path: "/",
    component: () => import("@/views/home.vue"),
  },
  {
    path: "/login",
    component: () => import("@/views/login.vue"),
  },
  {
    path: "/my",
    component: () => import("@/views/my.vue"),
  },
  {
    path: "/noticeList",
    component: () => import("@/views/noticeList.vue"),
  },
  {
    path: "/datarmine",
    component: () => import("@/views/datarmine.vue"),
  },
  {
    path: "/newsList",
    component: () => import("@/views/newsList.vue"),
  },
  {
    path: "/policyList",
    component: () => import("@/views/policyList.vue"),
  },
  {
    path: "/updatingList",
    component: () => import("@/views/updatingList.vue"),
  },
  {
    path: "/details",
    component: () => import("@/views/details.vue"),
  },
  {
    path: "/course",
    component: () => import("@/views/course.vue"),
  },
  {
    path: "/myCertificate",
    component: () => import("@/views/myCertificate.vue"),
  },
  {
    path: "/course/homePage",
    component: () => import("@/views/course/homePage.vue"),
  },
  {
    path: "/course/courseList",
    component: () => import("@/views/course/courseList.vue"),
  },
  {
    path: "/course/literature",
    component: () => import("@/views/course/literature.vue"),
  },
  {
    path: "/course/questionnaire",
    component: () => import("@/views/course/questionnaire.vue"),
  },
  {
    path: "/course/video",
    component: () => import("@/views/course/video.vue"),
  },
  {
    path: "/notiec_1",
    component: () => import("@/views/notiec_1.vue"),
  },
  {
    path: "/courseIndex",
    component: () => import("@/views/courseIndex.vue"),
  },
  {
    path: "/courseDetails",
    component: () => import("@/views/courseDetails.vue"),
  },
  {
    path: "/EducationRecord",
    component: () => import("@/views/EducationRecord.vue"),
  },
  {
    path: "/cart",
    component: () => import("@/views/cart.vue"),
  },
  {
    path: "/test",
    component: () => import("@/views/test.vue"),
  },
  {
    path: "/examinationPaper",
    component: () => import("@/views/examinationPaper.vue"),
  },
  {
    path: "/Skill",
    component: () => import("@/views/Skill.vue"),
  },
  {
    path: "/HelpCenter",
    component: () => import("@/views/HelpCenter.vue"),
  },
];

import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: routes,
});
